/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';

const IcepackFilledCustomModalCell = ({ rowData }) => {
	if (rowData.id === 'author') {
		return (
			<span className="icepack-filled-custom-modal-cell__author">
				<b>{rowData.value.name}</b>
				<small>
					<i>{rowData.value.role}</i>
				</small>
			</span>
		);
	}

	return rowData.value;
};

IcepackFilledCustomModalCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
};

export { IcepackFilledCustomModalCell };
